/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { createNews, getAllNews, deleteNews, publishScheduledNews, updateScheduledNews } from './newsApi';
import { NewsState } from './types';

const initialState: NewsState = {
    articles: [],
    scheduledArticles: [],
    publishedArticles: [],
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isPublishing: false,
    success: false,
    error: null,
};

export const newsSlice = createSlice({
    name: 'news',
    initialState,
    reducers: {
        clearNewsState: (state) => {
            state.success = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(createNews.pending, (state) => {
                state.isCreating = true;
                state.success = false;
                state.error = null;
            })
            .addCase(createNews.fulfilled, (state) => {
                state.isCreating = false;
                state.success = true;
            })
            .addCase(createNews.rejected, (state, action) => {
                state.isCreating = false;
                state.success = false;
                state.error = action.error.message || 'Failed to create news';
            })
            .addCase(getAllNews.pending, (state) => {
                state.isFetching = true;
                state.error = null;
            })
            .addCase(getAllNews.fulfilled, (state, action) => {
                state.isFetching = false;
                state.publishedArticles = action.payload.data.published || [];
                state.scheduledArticles = action.payload.data.scheduled || [];
            })
            .addCase(getAllNews.rejected, (state, action) => {
                state.isFetching = false;
                state.error = action.error.message || 'Failed to fetch news articles';
            })
            .addCase(deleteNews.pending, (state) => {
                state.isFetching = true;
                state.error = null;
            })
            .addCase(deleteNews.fulfilled, (state) => {
                state.isFetching = false;
                state.success = true;
            })
            .addCase(deleteNews.rejected, (state, action) => {
                state.isFetching = false;
                state.error = action.error.message || 'Failed to delete news article';
            })
            .addCase(publishScheduledNews.pending, (state) => {
                state.isPublishing = true;
                state.success = false;
                state.error = null;
            })
            .addCase(publishScheduledNews.fulfilled, (state) => {
                state.isPublishing = false;
                state.success = true;
            })
            .addCase(publishScheduledNews.rejected, (state, action) => {
                state.isPublishing = false;
                state.success = false;
                state.error = action.error.message || 'Failed to publish scheduled news';
            })
            .addCase(updateScheduledNews.pending, (state) => {
                state.isUpdating = true;
                state.success = false;
                state.error = null;
            })
            .addCase(updateScheduledNews.fulfilled, (state) => {
                state.isUpdating = false;
                state.success = true;
            })
            .addCase(updateScheduledNews.rejected, (state, action) => {
                state.isUpdating = false;
                state.success = false;
                state.error = action.error.message || 'Failed to update scheduled news';
            });
    },
});

export const { clearNewsState } = newsSlice.actions;
export default newsSlice.reducer;
